var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8193 17.1865C11.6279 17.8291 11.3545 18.082 10.8623 18.082C10.3564 18.082 10.0078 17.7744 10.0078 17.3096C10.0078 17.125 10.0557 16.9131 10.1719 16.5645L12.5234 9.82422C12.8174 8.95605 13.2344 8.59375 14.0137 8.59375C14.7861 8.59375 15.1963 8.94922 15.4902 9.82422L17.8418 16.5645C17.9375 16.8584 17.9854 17.084 17.9854 17.2754C17.9854 17.7676 17.6367 18.082 17.1104 18.082C16.6113 18.082 16.3242 17.8223 16.1396 17.1865L15.6133 15.6006H12.3389L11.8193 17.1865ZM13.9385 10.4531L12.749 14.2266H15.21L14.0273 10.4531H13.9385Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26C20.6274 26 26 20.6274 26 14C26 7.37258 20.6274 2 14 2ZM4 14C4 8.47715 8.47715 4 14 4C19.5228 4 24 8.47715 24 14C24 19.5228 19.5228 24 14 24C8.47715 24 4 19.5228 4 14Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextCircleOutline);
export default __webpack_public_path__ + "static/media/text_circle_outline.72f1ab6b7a57caa1ddc55a3500754afd.svg";
export { ForwardRef as ReactComponent };